<template>
  <modal
    name="alert"
    width="100%"
    height="auto"
    :scrollable="true"
    :adaptive="true"
    transition="fade-down"
    classes=""
    :clickToClose="true"
    @before-close="beforeClose">

    <div class="relative lg:h-auto lg:w-2/3 max-w-lg mx-auto flex flex-wrap bg-white">
      <div class="p-8 md:p-10 lg:p-16">
        <button @click="closeAlert()" class="absolute pin-r pin-t mt-3 mr-4" role="button">
          <svg class="close-dims text-orange w-5 h-5">
            <use xlink:href="#close"></use>
          </svg>
        </button>

        <slot></slot>

      </div>
    </div>

  </modal>
</template>

<script>
import { EventBus } from "../lib/event-bus.js";

const cookieName = "saucelito_alert"

export default {
  name: "Alert",

  props: {
    cookieSuffix: {
      default: '',
      type: String
    }
  },

  data: function () {
    return {
      show: this.open
    }
  },

  mounted() {
    const cookieValue = this.$cookie.get(cookieName + this.cookieSuffix)
    // const cookieValue = false

    if (!cookieValue) {
      this.openAlert()
    } else {

    }
  },

  created() {
    EventBus.$on('close-alert', () => this.closeAlert());
  },

  methods: {
    openAlert() {
      this.$modal.show('alert');
    },
    closeAlert() {
      this.$modal.hide('alert');
    },
    beforeClose() {
      this.$cookie.set(cookieName + this.cookieSuffix, true, { expires: '7D' });
    }
  }
}
</script>



// WEBPACK FOOTER //
// _js/components/Alert.vue